export type BaseExpandType = 'songs' | 'files' | 'distribution_details'

export type TBaseExpandOptions = {
  songs?: boolean
  files?: boolean
  distribution_details?: boolean
}

export const createExpandString = (expands: Record<string, boolean>): string => {
  const expandList: string[] = []

  Object.entries(expands).forEach(([key, value]) => {
    if (value) {
      expandList.push(key)
    }
  })

  return expandList.join(',')
}

export const createExpandMeta = (expands: Record<string, boolean>) => {
  const expandString = createExpandString(expands)
  return expandString ? { expand: expandString } : undefined
}

export const COMMON_EXPAND_PRESETS = {
  SONGS_ONLY: createExpandMeta({ songs: true }),
  FILES_ONLY: createExpandMeta({ files: true }),
  DISTRIBUTION_DETAILS_ONLY: createExpandMeta({ distribution_details: true }),
  SONGS_AND_FILES: createExpandMeta({ songs: true, files: true }),
  DISTRIBUTION_DETAILS_AND_SONGS: createExpandMeta({ distribution_details: true, songs: true }),
} as const
